import { createApp } from 'vue'
import App from './App.vue'
import './assets/tailwind.css'
import './assets/preparation.css'
import router from './router'; // Import the router

const app = createApp(App);

app.use(router); // Use the router in the app

app.mount('#app');